import { type SelectOption } from '@factorialco/deprecated-design-system'

import { Trigger } from 'modules/automations/store/models/Trigger'

import {
  applicationOptions,
  defaultOptions,
  documentOptions,
  groupOptions,
  leaveOptions,
} from '../../CommonNotification/options'
import { defaultRecipientTypes, recipientTypes } from '../../CommonNotification/types'

export const userOptions = (trigger: string): SelectOption[] => {
  switch (trigger) {
    case Trigger.Slugs.documentCreated:
    case Trigger.Slugs.documentUpdated:
    case Trigger.Slugs.documentMadePublic:
      return documentOptions()

    case Trigger.Slugs.leaveCreated:
    case Trigger.Slugs.leaveUpdated:
      return leaveOptions()

    case Trigger.Slugs.applicationCreated:
    case Trigger.Slugs.applicationDisqualified:
      return applicationOptions()

    default:
      return defaultOptions()
  }
}

export { groupOptions, recipientTypes, defaultRecipientTypes }
